import { Autocomplete, Box, Button, createFilterOptions, Dialog, DialogContent, DialogContentText, DialogTitle, TextField, Typography } from '@mui/material'
import LinkIcon from '@mui/icons-material/Link';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import MonitorIcon from '@mui/icons-material/Monitor';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { api } from 'src/api/endpoints';
import { useDispatch } from 'react-redux';
import { updateScreenScheduler } from 'src/redux/actions/Screen';
import toast from 'react-hot-toast';

const DetachSchedulerDialog = ({open, onClose, screenData, syncScreensByMac}) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const handleDetachScheduler = async () => {
        try {
            const resp = await api.patch('/scheduler/detachScheduler', {
                screenId: screenData._id,
            })

            dispatch(updateScreenScheduler(resp.data?.screen))
            syncScreensByMac([resp.data?.screen.mac])
            onClose()
        } catch (err) {
            toast.error(t("views.scheduler.serverErr"))
        }
    }

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle textAlign="center" variant="h5">{t("views.scheduler.detachAreYouSure")}</DialogTitle>
            <DialogContent sx={{
                display: "flex",
                flexDirection: "column",
                gap: '20px',
                mt: 2
            }}>
                {/* <Typography variant='h5' textAlign="center">{t("views.scheduler.detachAreYouSure")}</Typography> */}
                <Box sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    <MonitorIcon />
                    <Typography textAlign="subtitle1">{screenData?.deviceName}</Typography>
                </Box>
                <Box sx={{
                    display: "flex",
                    justifyContent: "center"
                }}>
                    <Button variant='outlined' sx={{
                        mr: 2
                    }} onClick={handleDetachScheduler}>{t("views.scheduler.detach")}</Button>
                    <Button variant='outlined' color="error" onClick={onClose}>{t("views.scheduler.cancel")}</Button>
                </Box>
            </DialogContent>
        </Dialog>
    )
}

export default DetachSchedulerDialog
